import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconSortDescending';
/** Renders an SVG icon. */
const SvgSortDescending = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22.293 25.707a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L24 22.586V7a1 1 0 1 0-2 0v15.586l-3.293-3.293a1 1 0 0 0-1.414 1.414zM5 21a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1m0-6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1m0-6a1 1 0 0 0 1 1h9a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1"
      />
    </svg>
  );
};
SvgSortDescending.displayName = displayName;
export default SvgSortDescending;
